import posthog from "posthog-js";
import useBuildingsPageState from "recoilStore/useBuildingsPageState";
import { MapIcon, TableIcon } from "components/atoms/Icon";
import { Paragraph } from "components/atoms/Typography";

function ViewButton() {
    const { pageState, setPageState } = useBuildingsPageState();

    const handleViewChange = (view: PortfolioPageView) => {
        if (view === "map") {
            posthog.capture("portfolioPage_map_tab_clicked");
        }
        setPageState((prev) => ({ ...prev, view }));
    };

    return pageState.view === "table" ? (
        <button id="buildings-view-map-button" type="button" onClick={() => handleViewChange("map")}>
            <MapIcon />
            <Paragraph>Map</Paragraph>
        </button>
    ) : (
        <button id="buildings-view-table-button" type="button" onClick={() => handleViewChange("table")}>
            <TableIcon />
            <Paragraph>Table</Paragraph>
        </button>
    );
}

export default ViewButton;
